const loginRegister = () => {
    const selectors = {
        form: 'form',
        input: 'input',
        email: '[type="email"]',
        submit: '[type="submit"]',
    };
    const classes = {
        isNotValid: 'is-not-valid',
    };
    const loginRegisterSection = document.querySelector('[data-login-register]');
    if (loginRegisterSection) {
        const errorModals = loginRegisterSection.querySelectorAll('[data-error-modal]');
        const showReset = loginRegisterSection.querySelector('[data-show-password-reset]');
        const hideResets = loginRegisterSection.querySelectorAll('[data-hide-password-reset]');
        // Password Reset
        showReset.addEventListener('click', () => {
            loginRegisterSection.classList.add('login-register--reset-password');
        });
        hideResets.forEach((reset) => {
            reset.addEventListener('click', () => {
                loginRegisterSection.classList.remove('login-register--reset-password');
                const resetSent = loginRegisterSection.querySelector('[data-password-reset-sent]');
                if (resetSent) {
                    resetSent.remove();
                }
            });
        });
        // Form Errors
        if (errorModals) {
            errorModals.forEach((modal) => {
                const errorModalClose = modal.querySelector('[data-error-modal-close]');
                if (errorModalClose) {
                    errorModalClose.addEventListener('click', () => {
                        errorModals.forEach((modal) => {
                            modal.remove();
                        });
                    });
                }
            });
        }
        // Field Validation
        const matchRegex = (email) => {
            return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        };
        const checkEmailValue = (field) => {
            const email = field.value;
            if (matchRegex(email)) {
                field.classList.remove(classes.isNotValid);
            }
            else {
                field.classList.add(classes.isNotValid);
            }
            return false;
        };
        const checkRequiredFields = (field) => {
            if (field.value == '') {
                field.classList.add(classes.isNotValid);
            }
            else {
                field.classList.remove(classes.isNotValid);
            }
        };
        const forms = loginRegisterSection.querySelectorAll(selectors.form);
        forms.forEach((form) => {
            const submit = form.querySelector(selectors.submit);
            const inputs = form.querySelectorAll(selectors.input);
            const emailAddresses = form.querySelectorAll(selectors.email);
            if (emailAddresses) {
                emailAddresses.forEach((email) => {
                    email.addEventListener('keyup', () => {
                        checkEmailValue(email);
                    });
                });
            }
            if (inputs) {
                inputs.forEach((input) => {
                    input.addEventListener('keyup', () => {
                        checkRequiredFields(input);
                    });
                });
            }
            if (submit) {
                submit.addEventListener('click', () => {
                    if (inputs) {
                        inputs.forEach((input) => {
                            if (input.hasAttribute('required') && input.getAttribute('type') != 'email') {
                                checkRequiredFields(input);
                            }
                        });
                    }
                    if (emailAddresses) {
                        emailAddresses.forEach((email) => {
                            checkEmailValue(email);
                        });
                    }
                });
            }
            form.addEventListener('submit', () => {
                if (inputs) {
                    inputs.forEach((input) => {
                        if (input.hasAttribute('required') && input.getAttribute('type') != 'email') {
                            checkRequiredFields(input);
                        }
                    });
                }
                if (emailAddresses) {
                    emailAddresses.forEach((email) => {
                        checkEmailValue(email);
                    });
                }
            });
        });
    }
};
export { loginRegister };
